import { render, staticRenderFns } from "./BoostifyEdu.vue?vue&type=template&id=f689ec7e&scoped=true"
import script from "./BoostifyEdu.vue?vue&type=script&lang=js"
export * from "./BoostifyEdu.vue?vue&type=script&lang=js"
import style0 from "./BoostifyEdu.vue?vue&type=style&index=0&id=f689ec7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f689ec7e",
  null
  
)

export default component.exports